/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {Configuration, NetworkApi} from '@adobe/exc-app/network';
import fetchApi from './fetch';
import graphql from './graphql';
import internal from '../internal';
import Metrics, {Level} from '../metrics/lazyMetrics';

//invoked on every configure event
function configure(config: Configuration): void {
  internal.configureNetwork(config);
  const metrics = new Metrics('exc.module-runtime');
  metrics.event('Runtime.deprecationWarnings', 'Configure is deprecated.', {level: Level.WARN});
}

const network: NetworkApi = {
  configure,
  fetch: fetchApi.fetch,
  query: graphql.query
};

export default network;
